<template>
	<van-list
		v-model="loading"
		:finished="finished"
		:finished-text="translate('history_all_loaded')"
		@load="loadData"
		>
		<van-cell is-link v-for="(item, key) in lists" :key="key" :title="item.total" :label="item.date" @click="goInfo(item.id)">
			<template #right-icon>
				<span style="color: grey;" v-if="item.status == 1">{{translate('history_to_be_processed')}}</span>
				<span style="color: steelblue;" v-if="item.status == 2">{{translate('history_audited')}}</span>
				<span style="color: red;" v-if="item.status == 3">{{translate('history_cancelled')}}</span>
				<span style="color: green;" v-if="item.status == 4">{{translate('history_already_transferred')}}</span>
				<span style="color: steelblue;" v-if="item.status == 5">划款中</span>
			</template>
		</van-cell>
	</van-list>
</template>

<script>
	export default {
		name: 'withdraw_history',
		data() {
			return {
				loading: false,
				finished: false,
				
				lists: [],
				
				formItem: {
					page: 1,
					limit: 10,
					token: ""
				},
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.formItem.token = this.$route.query.token
				this.loadData()
			}
		},
		methods: {
			loadData() {
				this.loading = true
				
				this.$axios({
					method: 'post',
					url: 'cash_withdraw/history', 
					data: this.formItem
				}).then ((res) => {
					
					this.loading = false
					
					if (res.success) {
						if (res.data.length != 0) {
							this.lists = this.lists.concat(res.data)
							
							if (res.data.length < this.formItem.limit) {
								this.finished = true
							} else {
								this.formItem.page++
							}
						} else {
							this.finished = true
						}
					} else {
						this.$dialog.alert({
							message: res.error_text
						})
					}
				})
			},
			goInfo(id) {
				this.$router.push('/withdraw/info?id=' + id + '&token=' + this.formItem.token) 
			}
		}
	}
</script>